// AppContext.js
import React, { createContext, useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDarkMode } from "./darkModeContext";

const AppContext = createContext({});

export const AppProvider = ({ children }) => {
  const { darkMode } = useDarkMode();
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!localStorage.getItem("token")
  );
  const [showSideBar, setShowSideBar] = useState(false);
  const [currentMenu, setCurrentMenu] = useState({ title: "Insight" });
  const [currentSubMenu, setCurrentSubMenu] = useState({ title: "" });
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("user");
    return u ? JSON.parse(u) : null;
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "token") {
        if (!e.newValue) {
          window.location.href = "/login";
        } else {
          window.location.reload();
        }
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  return (
    <AppContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        setShowSideBar,
        showSideBar,
        currentMenu,
        setCurrentMenu,
        currentSubMenu,
        setCurrentSubMenu,
        user,
        setUser,
        setIsSidebarOpen,
        isSidebarOpen,
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop={false}
        pauseOnHover={false}
        closeButton={false}
        theme={darkMode ? "dark" : "light"}
        closeOnClick
        draggable
        pauseOnFocusLoss={false}
        // hideProgressBar={}
      />
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
